import React, { useState, useEffect, useContext } from "react";
import UserSubsidiaryReadOnlyRow from "./UserSubsidiaryReadOnlyRow";
import UserSubsidiaryTableRow from "./UserSubsidiaryTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function UserSubsidiaryTable({ key, setSubsidiary, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isUserSubsidiaryLoading, setIsUserSubsidiaryLoading] = useState(false);
	const [isSubsidiaryLoading, setIsSubsidiaryLoading] = useState(false);
	const [subsidiaries, setSubsidiaries] = useState([]);
	const [userSubsidiaries, setUserSubsidiaries] = useState([]);
	const [count, setCount] = useState(key);
	const closeText = t("page.close");
	const today = new Date().toISOString().split("T")[0];
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		starDate: today,
		endDate: "",
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchSubsidiaries();
		fetchUserSubsidiaries();
	}, []);

	const handleClose = (event) => {
		setSubsidiary(false);
	};

	function fetchSubsidiaries() {
		setError("");
		setIsSubsidiaryLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: false,
				companyId: initialValues.companyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetSubsidiaries", "/Service/CompanyService/GetSubsidiaries", requestOptions, retrieveSubsidiarySuccess, retrieveSubsidiaryFail);
		} catch (error) {
			setIsSubsidiaryLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveSubsidiaryFail(redirect) {
		setIsSubsidiaryLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.subsidiaryNotRetrieved"));
	}

	function retrieveSubsidiarySuccess(responseData) {
		let getSubsidiariesResponse;
		if (responseData) {
			getSubsidiariesResponse = responseData.getSubsidiariesResponse;
			if (getSubsidiariesResponse && getSubsidiariesResponse.errorCode === "0") {
				setSubsidiaries(getSubsidiariesResponse.subsidiaryList.slice());
			} else if (getSubsidiariesResponse && getSubsidiariesResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getSubsidiariesResponse) {
				setError(t("error.error") + " " + getSubsidiariesResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsSubsidiaryLoading(false);
	}

	function fetchUserSubsidiaries() {
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsUserSubsidiaryLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: true,
				companyId: initialValues.companyId,
				loginId: initialValues.loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetSubsidiariesForUser", "/Service/UserService/GetSubsidiariesForUser", requestOptions, retrieveUserSubsidiarySuccess, retrieveUserSubsidiaryFail);
		} catch (error) {
			setIsUserSubsidiaryLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveUserSubsidiaryFail(redirect) {
		setIsUserSubsidiaryLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userGetSubsidiaryFailed"));
	}

	function retrieveUserSubsidiarySuccess(responseData) {
		let getSubsidiariesForUserResponse;
		if (responseData) {
			getSubsidiariesForUserResponse = responseData.getSubsidiariesForUserResponse;
			if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "0") {
				setUserSubsidiaries(getSubsidiariesForUserResponse.subsidiaryList.slice())
			} else if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getSubsidiariesForUserResponse) {
				setError(t("error.error") + " " + getSubsidiariesForUserResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserSubsidiaryLoading(false);
	}

	const handleDeleteClick = (event, userSubsidiaryItem, completeCallback) => {
		event.preventDefault();
		deleteUserSubsidiary(userSubsidiaryItem, completeCallback);
	};
	const deleteUserSubsidiary = (userSubsidiaryItem, completeCallback) => {
		let action = 3;
		if (userSubsidiaryItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			subsidiaryCompanyId: userSubsidiaryItem.companyId,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserSubsidiaryAccess", "/Service/UserService/DeleteUserSubsidiaryAccess", requestOptions, deleteUserSubsidiarySuccess, deleteUserSubsidiaryFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteUserSubsidiaryFail(redirect, completeCallback) {
		setError(t("error.userSubsidiaryEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteUserSubsidiarySuccess(responseData, completeCallback) {
		let deleteUserSubsidiaryAccessResponse;
		if (responseData) {
			deleteUserSubsidiaryAccessResponse = responseData.deleteUserSubsidiaryAccessResponse;
			if (deleteUserSubsidiaryAccessResponse) {
				if (deleteUserSubsidiaryAccessResponse.errorCode === "0") {
					resetRowTable();
					refreshUserSubsidiary();
				} else {
					setError(t("error.error") + " " +
						deleteUserSubsidiaryAccessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};
	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (userSubsidiaries.length > 0) {
				userSubsidiaries.map((userSubsidiaryItem, index) => {
					if (userSubsidiaryItem.companyId === setValues.subsidiaryCompanyId) {
						setError(t("error.userSubsidiaryDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveUserSubsidiary(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (action === 2) {
			if (userSubsidiaries.length > 0) {
				userSubsidiaries.map((userSubsidiaryItem, index) => {
					if (userSubsidiaryItem.companyId === setValues.subsidiaryCompanyId) {
						found = true;
					}
				})
			}
			if (found) {
				saveUserSubsidiary(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (completeCallback) {
			completeCallback();
		}
	};
	const saveUserSubsidiary = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			subsidiaryCompanyId: setValues.subsidiaryCompanyId,
			userCompanyId: userCompanyId,
			startDate: setValues.startDate,
			endDate: setValues.endDate,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};
		try {
			FetchUtil.fetchAPI("AddUpdateUserSubsidiaryAccess", "/Service/UserService/AddUpdateUserSubsidiaryAccess", requestOptions, saveUserSubsidiarySuccess, saveUserSubsidiaryFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveUserSubsidiaryFail(redirect, completeCallback) {
		setError(t("error.userSubsidiaryEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveUserSubsidiarySuccess(responseData, completeCallback) {
		let addUpdateUserSubsidiaryAccessResponse;
		if (responseData) {
			addUpdateUserSubsidiaryAccessResponse = responseData.addUpdateUserSubsidiaryAccessResponse;
			if (addUpdateUserSubsidiaryAccessResponse) {
				if (addUpdateUserSubsidiaryAccessResponse.errorCode === "0") {
					resetRowTable();
					refreshUserSubsidiary();
				} else if (addUpdateUserSubsidiaryAccessResponse.errorCode === "1000") {
					//setError(addUpdateUserSubsidiaryAccessResponse.errorMessage);
					resetRowTable();
					refreshUserSubsidiary();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserSubsidiaryAccessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshUserSubsidiary() {
		fetchUserSubsidiaries();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isUserSubsidiaryLoading || isSubsidiaryLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.startDate")}</th>
										<th className="list-th">{t("page.endDate")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<UserSubsidiaryTableRow
											key={count}
											loginId={loginId}
											subsidiaries={subsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userSubsidiaries.length % 2) > 0) ? true : false} />
									}
									{(userSubsidiaries.length > 0) ? (
										userSubsidiaries.map((userSubsidiaryItem, index) => (
											<UserSubsidiaryReadOnlyRow
												key={count}
												t={t}
												userSubsidiaryItem={userSubsidiaryItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												setError={setError}
												handleSubmit={handleSubmit}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<UserSubsidiaryTableRow
											key={count}
											loginId={loginId}
											subsidiaries={subsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userSubsidiaries.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(userSubsidiaries.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.startDate")}</th>
										<th className="list-th">{t("page.endDate")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-user-sub-close"
									id="edit-user-sub-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default UserSubsidiaryTable;